import React from 'react';
import { Link } from 'react-router-dom';
import RouteSeo from '../seo/RouteSeo';
import { trackCtaClick } from '../analytics/ctaGoal';
import { ProductShot } from './LandingPage';
import '../App.css';

// The landing page for the November writing challenge ads (#1020): Google search, and
// the Instagram and Reddit creatives. Every claim here is already made on /features or
// /pricing. The trial's 30 days start at sign-up, so nothing here says it covers the
// month. NaNoWriMo and "Novel November" stay out of the text: the first is a trademark,
// the second is another company's event.
const NovemberPage = () => (
  <>
    <RouteSeo path="/november" />
    <div className="landing-page november-page">
      <section className="hero-content">
        <div className="container">
          <p className="november-eyebrow">The November writing challenge</p>
          <h1>Write your novel this November</h1>
          <p className="hero-subtitle">
            50,000 words in 30 days is 1,667 a day. Chaptery counts every word as you write,
            keeps your streak, and shows you exactly where you stand.
          </p>
          <div className="hero-actions">
            <Link to="/register" className="btn-primary-large" onClick={() => trackCtaClick('november')}>Start Free</Link>
          </div>
          <p className="hero-trial-note">
            30 days free · No credit card · Start in your browser now, write in the
            desktop app for macOS &amp; Windows
          </p>
          <ProductShot
            className="hero-shot"
            name="writing-dashboard-november"
            eager
            desktop={{ w: 1058, h: 812 }}
            mobile={{ w: 1000, h: 438 }}
            alt="A writing dashboard showing 2,490 words today against a 1,667-word daily goal, and an eleven day streak"
            caption="Words today, this week, this month, and the streak you are keeping."
          />
        </div>
      </section>

      <section className="november-section">
        <div className="container november-narrow">
          <h2>Watch the words add up</h2>
          <ul className="features-list">
            <li>Set a daily goal of 1,667 words, or whatever your November needs</li>
            <li>A streak counting every day you hit it</li>
            <li>Today, this week, and this month at a glance</li>
            <li>Words per day for the last 30 days, with your goal line drawn across it</li>
            <li>Nothing to start and nothing to log: it counts as you write</li>
          </ul>
        </div>
      </section>

      <section className="november-section november-section-tinted">
        <div className="container">
          <div className="november-narrow">
            <h2>Plan before the first of November</h2>
            <p>
              Build your cast, your places and your timeline of events before day one, and see
              how they connect on the relationship map. When November starts, it's all organized
              beside your manuscript.
            </p>
          </div>
          <div className="product-tour november-tour">
            <ProductShot
              className="tour-shot"
              name="november-world"
              desktop={{ w: 1688, h: 872 }}
              mobile={{ w: 920, h: 744 }}
              alt="The World Building map: Elena Voss linked to Marcus Thane as mentor and to Cassian Vane as rival, with an event and two locations"
              caption="Your cast, your places and your events, and how they connect."
            />
          </div>
        </div>
      </section>

      <section className="november-section">
        <div className="container">
          <div className="november-narrow">
            <h2>A focused editor for long-form work</h2>
            <p>A native app for Mac and Windows, with cloud sync and every revision of your manuscript kept safe.</p>
          </div>
          <div className="product-tour november-tour">
            <ProductShot
              className="tour-shot"
              name="november-editor"
              desktop={{ w: 1600, h: 1030 }}
              mobile={{ w: 662, h: 872 }}
              alt="The Chaptery editor: the book's outline of front matter, chapters and back matter beside the first page of chapter one"
              caption="Every chapter in the outline, and the page in front of you."
            />
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Ready for November 1?</h2>
          <p>Your 30 free days start the day you sign up: one book, every feature, no credit card.</p>
          <Link to="/register" className="btn-primary-large" onClick={() => trackCtaClick('november-footer')}>Start Free</Link>
        </div>
      </section>
    </div>
  </>
);

export default NovemberPage;
